var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1319_918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5016 6.70648C13.7434 6.68725 14.9443 7.1529 15.8523 8.00571L18.2981 5.59848C16.729 4.11853 14.6518 3.307 12.5016 3.33384C10.895 3.33346 9.32 3.78294 7.95269 4.63199C6.58539 5.48105 5.4797 6.69621 4.75928 8.14159L7.56171 10.3316C7.90437 9.28285 8.56546 8.36884 9.45174 7.71845C10.338 7.06805 11.4048 6.71409 12.5016 6.70648Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8203 12.2508C20.8305 11.6512 20.7689 11.0525 20.6369 10.4677H12.5005V13.7053H17.277C17.1864 14.2729 16.9827 14.8162 16.6781 15.3025C16.3735 15.7889 15.9743 16.2082 15.5046 16.5352L18.2395 18.6673C19.0919 17.839 19.7622 16.84 20.2071 15.7348C20.6521 14.6296 20.8618 13.4427 20.8228 12.2508H20.8203Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57084 13.7822C7.38136 13.2269 7.28368 12.6441 7.28168 12.0569C7.28514 11.4707 7.37932 10.8886 7.56084 10.3316L4.75841 8.1416C4.15059 9.35624 3.83398 10.6973 3.83398 12.0573C3.83398 13.4173 4.15059 14.7584 4.75841 15.9731L7.57084 13.7822Z",
    fill: "#6ABCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5009 20.78C14.6119 20.8401 16.6656 20.084 18.2399 18.6671L15.505 16.535C14.6182 17.1334 13.568 17.4383 12.5009 17.4073C11.405 17.4008 10.339 17.0471 9.45411 16.3964C8.56922 15.7457 7.91035 14.831 7.57098 13.7822L4.76855 15.9731C5.48704 17.4178 6.59092 18.6327 7.95657 19.4817C9.32222 20.3306 10.8957 20.7802 12.5009 20.78Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1319_918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.3333,
    height: 17.3333,
    fill: "white",
    transform: "translate(3.8335 3.33319)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.a348eaa2e41c5481fdf63b7f31ba8a5b.svg";
export { ForwardRef as ReactComponent };